export default __webpack_public_path__ + "static/media/girl2.16239637.svg";